
import { supabase } from '@/integrations/supabase/client';
import { FeedbackFormData, FeedbackTicket } from '@/types/feedback';

export const uploadFeedbackScreenshot = async (screenshot: File, userId: string): Promise<string | undefined> => {
  try {
    const fileExt = screenshot.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}.${fileExt}`;
    const filePath = `${userId}/${fileName}`;
    
    console.log('Attempting to upload file to feedback bucket, path:', filePath);
    
    const { error: uploadError, data: uploadData } = await supabase.storage
      .from('feedback')
      .upload(filePath, screenshot);
    
    if (uploadError) {
      console.error('Error uploading file:', uploadError);
      return undefined;
    }
    
    console.log('File uploaded successfully:', uploadData);
    const { data: urlData } = supabase.storage
      .from('feedback')
      .getPublicUrl(filePath);
    
    return urlData.publicUrl;
  } catch (error) {
    console.error('Error in uploadFeedbackScreenshot:', error);
    return undefined;
  }
};

export const submitFeedbackTicket = async (
  formData: FeedbackFormData,
  _userId: string,
  screenshotUrl?: string
) => {
  // Prepare the submission data with proper typing for Supabase function
  const submissionData = {
    category: formData.type,
    description: formData.description,
    urgency: formData.urgency,
    contact_preference: formData.contactMethod,
    steps: formData.steps || null,
    phone_number: formData.phoneNumber || null,
    additional_comments: formData.additionalComments || null,
    screenshot_url: screenshotUrl || null,
    page_source: formData.pageSource || null,
    technique_name: formData.type === 'Technique Request' ? formData.techniqueName || null : null
  };
  
  console.log('Submitting feedback with data:', submissionData);
  
  const { data, error } = await supabase.functions.invoke(
    'submit_feedback',
    { body: JSON.stringify(submissionData) }
  );
  
  if (error) {
    console.error('Error submitting feedback:', error);
    throw error;
  }
  
  console.log('Feedback submitted successfully:', data);
  return data;
};

export const sendConfirmationEmail = async (
  ticketData: FeedbackTicket,
  userId: string,
  feedbackData: FeedbackFormData
) => {
  return supabase.functions.invoke('send-feedback-email', {
    body: JSON.stringify({
      ticketId: ticketData.id,
      userId: userId,
      category: feedbackData.type,
      description: feedbackData.description,
      urgency: feedbackData.urgency,
      contactPreference: feedbackData.contactMethod,
      pageSource: feedbackData.pageSource,
      techniqueName: feedbackData.type === 'Technique Request' ? feedbackData.techniqueName || null : null
    })
  });
};
